/* eslint-disable camelcase */
import React, { FC, useCallback, useEffect, useMemo, useRef, memo } from "react"
import { Appearance, ScrollView } from "react-native"
import { CompositeScreenProps, useIsFocused } from "@react-navigation/native"
import { CycleCreateMultipleForm as ModelForm, ModelCreateMultipleScreen } from "../../../../components"
import { observer } from "mobx-react-lite"
import { useStores } from "../../../../models"
import { Cycle } from "../../../../database"
import JalaAnalytic from "../../../../utils/jala-analytic"
import { exitWalkthrough, startWalkthrough } from "react-native-walkthrough"
import formWalkthrough from "../../../../guides/form-walkthrough"
import { translate } from "../../../../i18n"
import { ConnectionWeakModal } from "../../farm/farm-create/farm-create-screen"

const FormWalkthrough: FC<{
  scrollViewRef?: { current: ScrollView }
}> = memo(observer(function FormWalkthrough(props) {
  const { scrollViewRef } = props
  const { userStore } = useStores()
  const { user } = userStore
  const isFocused = useIsFocused()

  useEffect(() => {
    if (!isFocused || !user || user?.state?.add_start_create_cycle_coachmark_shown) return undefined
    startWalkthrough(formWalkthrough(
      [
        {
          id: 'cycle-form-second',
          content: translate("paramTooltip"),
          placement: 'top',
          tooltipProps: {},
        }
      ], () => {
        userStore.updateData({ state: { add_start_create_cycle_coachmark_shown: true } })
          .finally(() => userStore.getUser())
        if (scrollViewRef && scrollViewRef.current)
          return scrollViewRef.current.scrollTo({ y: 0 })
      },
    ))
    return () => isFocused && exitWalkthrough();
  }, [isFocused, scrollViewRef, user, userStore])

  return null
}))

export const CycleCreateMultipleScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function CycleCreateMultipleScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme(), route: { params = {} } } = props

  // Pull in one of our MST stores
  const {
    appStore: { farmStore, farmId },
    cycleStore: modelStore,
  } = useStores();

  const scrollViewRef = useRef<ScrollView>(null)

  const initialValues = useMemo<any>(() => {
    return {
      farm_id: farmId,
      models: params.models || []
    }
  }, [farmId, params.models])

  const onSuccess = useCallback((success: boolean) => {
    if (modelStore.needRefresh) {
      if (success) {
        farmStore.initWithLastBatchAndWaterQualityMultiMeasurements(() => {
          modelStore.set('needRefresh', false);
          modelStore.set('pushIdQueue', {})
        });
      } else {
        modelStore.set('needRefresh', false);
        modelStore.set('pushIdQueue', {})
      }
    }
    return success;
  }, [farmStore, modelStore])

  const editing = !!(params.models || []).filter((m) => m.id).length;
  const denyAddOnMultiple = !!(params.models || []).length;

  useEffect(() => {
    if (editing) JalaAnalytic.log('Mobile: Visit Setting Cycle');
  }, [editing])

  return (<>
    <ModelCreateMultipleScreen
      colorScheme={colorScheme}
      ModelForm={ModelForm}
      modelFormProps={{
        denyAddOnMultiple: denyAddOnMultiple
      }}
      initialValues={initialValues}
      modelStore={modelStore}
      Model={Cycle}
      onSuccess={onSuccess}
      saveTx={!editing && "cycleCreateMultipleScreen.title" || undefined}
      hideOnBlurred={false}
      scrollViewRef={scrollViewRef}
    />
    <ConnectionWeakModal />
    <FormWalkthrough scrollViewRef={scrollViewRef} />
  </>)
})
